import type { DataSourceDataParams } from "@infinite-table/infinite-react";
import type { News } from "epsm-api-types/models";

export function setNewDataParams(
	tableParams: DataSourceDataParams<News>,
	setDataParams: (v: Partial<DataSourceDataParams<News>>) => void,
) {
	const { groupBy, sortInfo, livePaginationCursor, filterValue } = tableParams;

	const params = {
		groupBy,
		sortInfo,
		filterValue: filterValue ?? [],
		livePaginationCursor,
	};

	setDataParams(params);
}
